/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-07-01 10:50:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-12-31 13:09:45
 * @FilePath: /src/components/GlobalDialog/PrivacyPolicy/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { fetchJSONValue } from '@/api/public';
import Button from '@/components/Button';
import PopupResponsive from '@/components/PopupResponsive';
import { Skeleton } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';

interface ProtocolInformationProps {
  show: boolean;
  onClose: () => void;
}

export default function ProtocolInformation({ show, onClose }: ProtocolInformationProps) {
  const globalT = useTranslations();
  const [innerText, setInnerText] = useState<string>('');

  const [loading, setLoading] = useState(false);
  const getBlockValue = async () => {
    setLoading(true);
    const { data } = await fetchJSONValue(['privacy_policy']);
    // @ts-ignore: JSON.parse returns any type and privacy_policy structure is not fully typed
    const _innerText = JSON.parse(data?.privacy_policy?.json_value) || { text_pc: '' };
    // @ts-ignore: _innerText structure from JSON is not strictly typed
    setInnerText(_innerText?.text_pc || '');

    setLoading(false);
  };

  useEffect(() => {
    if (show && !innerText) {
      getBlockValue();
    }
  }, [show]);

  return (
    <PopupResponsive
      open={show}
      onClose={onClose}
      height="80%"
      title=""
      showDivider={false}
      sx={{
        '& .popup-content': {
          padding: '16px 14px',
          overflowX: 'hidden',
        },
      }}
      footer={
        <div className="w-full flex items-center justify-center lg:py-16 lg:border-t">
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: '100%',
              maxWidth: '256px',
              height: { xs: '44px', md: '52px' },
              fontFamily: 'var(--font-bricolage-bold)',
            }}
            onClick={onClose}
          >
            {globalT('common.button.confirm')}
          </Button>
        </div>
      }
    >
      <div className="bg-white rounded-lg w-full relative h-[100%]">
        {loading ? (
          <div className="flex flex-col gap-4 items-center justify-center h-full">
            <Skeleton animation="wave" width="100%" height={40} variant="text" />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
          </div>
        ) : (
          <div className={`${styles.inner}`} dangerouslySetInnerHTML={{ __html: innerText }} />
        )}
      </div>
    </PopupResponsive>
  );
}
